import axios from "http/customAxios";
import { generateBase58uuid } from "../../witadmin/CRUD/utils";

export interface PayNoPainTransactionDto {
  id: string;
  orderNumber: string;
  amount: {
    amount: number;
    currency: string;
  };
  cardPan: string;
  transactionType: string;
  operationType: string;
  responseCode: string;
  user: string;
  description: string;
  creationDate: string;
  status: string;
  hasRefund: boolean;
}

export interface PayNoPainOperationPayloadDto {
  transactionId?: string;
  reservationId: string;
  description?: string;
  amount: number;
  username?: string;
}

export class PayNoPainApi {
  public readonly baseUrl: string;
  public readonly propertyTicker: string;

  constructor(baseUrl: string, propertyTicker: string) {
    this.baseUrl = `${baseUrl}/api/payments/paynopainv2`;
    this.propertyTicker = propertyTicker;
  }

  async listTransactions(reservationId: string): Promise<PayNoPainTransactionDto[]> {
    const endpoint = `${this.baseUrl}/transactions/${this.propertyTicker}/${reservationId}`;
    const response = await axios.get<PayNoPainTransactionDto[]>(endpoint, {
      headers: {
        "x-property": this.propertyTicker,
      },
    });
    return response.data.map(it => ({
      ...it,
      amount: { ...it.amount, amount: Number(it.amount.amount.toFixed(2)) },
    }));
  }

  async charge({
    reservationId,
    description,
    username,
    amount,
  }: PayNoPainOperationPayloadDto): Promise<void> {
    const endpoint = `${this.baseUrl}/charge/${generateBase58uuid()}`;
    await axios.put(
      endpoint,
      {
        reservationId,
        description: description || "CHARGE",
        propertyTicker: this.propertyTicker,
        user: username,
        amount,
      },
      {
        headers: {
          "x-property": this.propertyTicker,
        },
      }
    );
  }

  async deposit(reservationId: string, orderNumber: string): Promise<void> {
    const endpoint = `${this.baseUrl}/properties/${this.propertyTicker}/reservations/${reservationId}/deposit/${orderNumber}`;
    await axios.put(endpoint, null, {
      headers: {
        "x-property": this.propertyTicker,
      },
    });
  }

  async refund({
    transactionId,
    reservationId,
    username,
    amount,
  }: PayNoPainOperationPayloadDto): Promise<void> {
    const endpoint = `${this.baseUrl}/refund/${transactionId}`;
    await axios.put(
      endpoint,
      {
        reservationId,
        propertyTicker: this.propertyTicker,
        user: username,
        amount,
      },
      {
        headers: {
          "x-property": this.propertyTicker,
        },
      }
    );
  }
}
